export var ChatStateData;
(function (ChatStateData) {
    ChatStateData["COMPOSING"] = "composing";
    ChatStateData["PAUSED"] = "paused";
    ChatStateData["INACTIVE"] = "inactive";
    ChatStateData["GONE"] = "gone";
})(ChatStateData || (ChatStateData = {}));
//# sourceMappingURL=chat-state-data.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/message/chat-state-data.js
// module id = 992
// module chunks = 14